import React, {
  ReactElement,
  ReactNode,
  useEffect,
  useRef,
  useState
} from 'react';
import './CCMPatientsDrawerDetails.scss';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Link,
  Tooltip
} from '@material-ui/core';
import {Trans, useTranslation} from 'react-i18next';
import // ColumnDef
'@components/system/MinGridTable/MinGridTable';
import {ExpandLess, ExpandMore} from '@material-ui/icons';
import CustomPopOver, {
  CustomPopOverListItemType
} from '@components/system/CustomPopOver/CustomPopOver';
import {useDispatch, useSelector} from 'react-redux';
import {
  _setActiveTab,
  _setPatientDrawerPatientDetails
} from '@shared/store/actions/PatientDrawerAction';
import {
  AppPermissions,
  CCMAdminRole,
  CCMConstants,
  FOLLOW_UP_NOTES_LOG_STATUS,
  PatientsTabKeys
} from '@shared/constants/Mapping';
import GridTable, {
  DEFAULT_GRID_TABLE__OPTIONS
} from '@components/system/GridTable/GridTable';
import {
  CUSTOM_PAGINATION_SIZE_OPTIONS,
  PAGINATION_SIZE
} from 'src/constants/SystemConstants';
import {APP, DEFAULT_BLACK_COLOR} from 'src/style/variable';

import HelperUtils from '@shared/utils/HelperUtils';
import DateTimePickerWrapper from '@components/system/CustomDateTimePicker/DateTimePickerWrapper';

import CCMCreatePlanDialog from '../CCMCreatePlanDialog/CCMCreatePlanDialog';
import {
  CCMPatientPlanRowLogsStyle,
  GuarantorCellStyle,
  GuarantorHeaderStyle
} from 'src/modules/admin/modules/Invoices/TableStyles';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {
  archiveCCMPatient,
  cancelCCMPlan,
  createExternalCCMPlanforPatient,
  deleteCCMPlan,
  getAllCCMPatientLogDetails,
  getAllCCMUsersOfClinicGroup,
  ingnoreCCMLog,
  updatePrevFollowUpNotesLog
} from '@shared/services/CCMServices';
import {useSnackbar} from 'notistack';
import RecordDetailsDialog from '../CCMRecordDetails/RecordDetailsDialog';
import WithPermission from '@components/system/WithPermission/WithPermission';
import ConfirmationDialog from '@components/system/ConfirmationDialog/ConfirmationDialog';
import CCMLogRecordDetailsDialog from '../CCMRecordDetails/CCMLogRecordDetailsDialog';
import {CommunicationService} from 'src/service/CommunicationService';
import {
  _ccmResetTimer,
  _ccmStopTimer,
  _startTimerfromPatientDrawer
} from '@shared/store/actions/CCMTimerActions';
import WarningTimerDialog from '../StopTimerDialog/WarningTimerDialog';
import StopTimerDialog from '../StopTimerDialog/StopTimerDialog';
import {secondsToTimeFormat} from '../StopTimerDialog/TimerUtils';
import Storage from 'src/utils/Storage';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import moment from 'moment';
import AddCcmTimeDialog from '../addCcmTimeDialog/AddCcmTimeDialog';
import {appointmentsDateTimeFormat} from '@shared/utils/DateTimeUtils';
import {CancelTokenSource, axios} from '@shared/axios';
import CCMShowFullNotesDialog from '../CCMShowFullNotesDialog/CCMShowFullNotesDialog';
import {UserModelMapper} from '@shared/services/service-mappers/ModelMapper';
import CCMAssigneeAndDueDateDialog from '../CCMAssigneeAndDueDate/CCMAssigneeAndDueDateDialog';
import {State} from '@shared/store/reducers/Index';
import Loader from '@components/framework/loader/Loader';
import CCMPatientProblemsDrawer from '../CCMPatients/CCMActiveProblems/CCMPatientProblemsDrawer';

const CCMPatientsDrawerDetails = (props: any): ReactElement => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const [remainderAnchorEl, setRemainderAnchorEl] = useState<any>(null);
  const [openPopover, setPopoverOpen] = useState<boolean>(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const tableRef: any = React.useRef();

  // use state for opening messages conversation from dialog
  const [stateShowDialog, setStateShowDialog] = useState({
    patientName: '',
    openCreatePlanDialog: false,
    editDialog: false,
    openRecordDetailsDialog: false,
    confirmationDialog: false,
    showCcmLogRecordDetails: false,
    cancelCCMState: false,
    showStopTimerCancelCCM: false,
    showStopTimerDialog: false,
    stopTimerWarningDialog: false,
    showStartTimerDialogToViewRecordDetails: false,
    recordDetailsEventBoolean: false,
    openAddCcmTimeDialog: false,
    apiResponse: [],
    selectedRowData: {},
    moreDetails: false,
    notes: '' as ReactNode,
    moreDetailsTitle: '',
    openAssigneeDueDateDialog: false,
    selectedRowLogId: null,
    selectedRowCCMPatientId: null,
    selectedPatientName: ''
  });
  const {
    openCreatePlanDialog,
    editDialog,
    patientName,
    openRecordDetailsDialog,
    confirmationDialog,
    showCcmLogRecordDetails,
    cancelCCMState,
    // apiResponse,
    showStopTimerCancelCCM,
    selectedRowData,
    showStopTimerDialog,
    stopTimerWarningDialog,
    showStartTimerDialogToViewRecordDetails,
    recordDetailsEventBoolean,
    openAddCcmTimeDialog,
    moreDetails,
    notes,
    moreDetailsTitle,
    openAssigneeDueDateDialog,
    selectedRowLogId,
    selectedRowCCMPatientId,
    selectedPatientName
  } = stateShowDialog;

  const [startDate, setStartDate] = useState<Date | any>(new Date());

  const [startDateErrorMessage, setStartDateErrorMessage] = useState('');

  const [patientLogs, setPatientLogs]: any = useState([]);

  const [ccmUsers, setCcmUsers] = useState<Array<UserModelMapper>>([]);

  const dispatch = useDispatch();

  const groupId: any = useSelector((state: any) => state.auth.groupId);
  const clinicId: any = useSelector(
    (state: any) => state.patientDetailsDrawer.clinicId
  );

  const isPlanActive = useSelector(
    (state: any) => state.patientDetailsDrawer.patientDetails.is_plan_active
  );

  const isExternalPlanActive = useSelector(
    (state: any) =>
      state.patientDetailsDrawer.patientDetails.is_external_care_plan
  );
  const [isLoading, setIsLoading] = React.useState(false);

  const patientDetails = useSelector(
    (state: any) => state.patientDetailsDrawer.patientDetails
  );

  const CompletePatientDetails: any = useSelector(
    (state: any) => state.patientDetailsDrawer
  );

  const {
    isTimerRunning: isCCMTimerRunning,
    ccmPatientId: runningCCMPatientId,
    startTimerfromPatientDrawer
  } = useSelector((state: any) => state.ccmTimer);

  let localStorageData: any = Storage.getItem(
    CCMConstants.STORAGE_CCM_TIMER_DATA
  );
  if (localStorageData) {
    localStorageData = JSON?.parse?.(localStorageData);
  }

  const ccmTimeLogReq = useRef<CancelTokenSource | null>(null);

  const [showIgnoredLogs, setShowIgnoredLogs] = useState<boolean>(false);

  const userInfo = useSelector((state: any) => state.auth.user);
  const userRoles = userInfo?.user_role || [];
  const isCCMAdminRole = userRoles.find(
    (role: any) => String(role.role_id) === CCMAdminRole.value
  );

  const fetchCCMPatientTimeLogs: any = async (
    fetchSize?: number,
    offset?: number,
    sorting?: {sort: string; order: string}
  ) => {
    try {
      const options: any = {};
      if (fetchSize) {
        options.limit = fetchSize;
      }
      if (offset && offset >= 0) {
        options.offset = offset;
      }
      // if(clinic)
      if (clinicId) {
        options.clinic_id = clinicId;
      }

      if (startDate) {
        const month = startDate?.getMonth() + 1;
        const year = startDate?.getFullYear();

        options.month = month;
        options.year = year;
      }

      if (ccmTimeLogReq.current) {
        ccmTimeLogReq.current.cancel();
      }
      options.is_ignored = showIgnoredLogs;

      ccmTimeLogReq.current = axios.CancelToken.source();
      const response = await getAllCCMPatientLogDetails(
        groupId,
        patientDetails?.ccm_patient_id,
        options,
        ccmTimeLogReq.current
      );
      if (response.data) {
        setPatientLogs(response.data);
      }
      return response;
    } catch (err: any) {
      enqueueSnackbar(
        (err && err.message) || t('PATIENTS.GET_ALL_PATIENTS_ERROR'),
        SnackBarConfig('e')
      );
      throw err;
    }
  };

  const resetFilter = (e: any) => {
    e.stopPropagation();
    // reset to current month
    setStartDate(new Date());
    setStartDateErrorMessage('');
    fetchCCMPatientTimeLogs();
  };

  const handleChangeStartDate = (dateParam: any) => {
    if (dateParam?.isValid()) {
      const currentMonth = moment().month();
      const currentYear = moment().year();
      if (
        currentYear < dateParam?.year() ||
        (currentYear === dateParam?.year() && currentMonth < dateParam?.month())
      ) {
        setStartDateErrorMessage(
          t('PATIENT_DETAILS_DRAWER.CCM_MODULE.BILLING_MONTH_MESSAGE')
        );
      } else {
        setStartDateErrorMessage('');
      }
      setStartDate(dateParam?.toDate() || null);
    } else {
      setStartDateErrorMessage(
        t('PATIENT_DETAILS_DRAWER.CCM_MODULE.BILLING_MONTH_VALID')
      );
    }
  };

  const renderIgnoredLogsCheckbox = (): ReactElement => {
    return (
        <div className="show-ignored-logs-checkbox">
          <FormControlLabel
            control={
              <Checkbox
                checked={showIgnoredLogs}
                onChange={(e) => {
                  setShowIgnoredLogs(e.target.checked);
                  setTimeout(() => {
                    resetPagesInGrid(0);
                  }, 100);
                }}
                color="primary"
              />
            }
            label={
              <span className="ignored-logs-label">
                {t('PATIENT_DETAILS_DRAWER.CCM_MODULE.SHOW_IGNORED_LOGS')}
                {showIgnoredLogs && (
                  <span className="ignored-logs-helper-text">
                    ({t('PATIENT_DETAILS_DRAWER.CCM_MODULE.SHOWING_IGNORED_LOGS')})
                  </span>
                )}
              </span>
            }
          />
        </div>

    );
  };

  const renderBillingMonth = (): ReactElement => {
    return (
      <div className="ccm-billing-month ">
        <div className="billing-month-title">
          {t('PATIENT_DETAILS_DRAWER.CCM_MODULE.BILLING_MONTH')}
        </div>

        <div className="fields-margin">
          <FormControl variant="outlined" error={!!startDateErrorMessage}>
            <DateTimePickerWrapper
              clearable
              maxDate={new Date()}
              views={['month', 'year']}
              format={'MM/YYYY'}
              value={startDate}
              placeholder={t(
                'PATIENT_DETAILS_DRAWER.CCM_MODULE.SELECT_MONTH_AND_YEAR'
              )}
              onChange={handleChangeStartDate}
            />
            {startDateErrorMessage && (
              <FormHelperText>{startDateErrorMessage}</FormHelperText>
            )}
          </FormControl>
          <Button
            color="primary"
            variant="contained"
            className={'clear-button'}
            onClick={resetFilter}>
            {t('PATIENT_DETAILS_DRAWER.CCM_MODULE.RESET_BUTTON')}
          </Button>
        </div>
        <div className='ignored-logs'>
          {renderIgnoredLogsCheckbox()}
        </div>
      </div>
    );
  };

  const isTimeRunningForCurrentPatient =
    isCCMTimerRunning && runningCCMPatientId == patientDetails?.ccm_patient_id;

  const popOverItems: Array<CustomPopOverListItemType> = [
    {
      name: t('PATIENT_DETAILS_DRAWER.CCM_MODULE.CREATE_PLAN'),
      id: 'create_plan',
      should_show: !isPlanActive
    },
    {
      name: isLoading ? (
        <Loader size="small" />
      ) : (
        t('PATIENT_DETAILS_DRAWER.CCM_MODULE.CREATE_EXTERNAL_CARE_PLAN')
      ),
      // name: t('PATIENT_DETAILS_DRAWER.CCM_MODULE.CREATE_EXTERNAL_CARE_PLAN'),
      id: 'create_external_care_plan',
      should_show: !isPlanActive && !isExternalPlanActive
    },
    {
      name: t('PATIENT_DETAILS_DRAWER.CCM_MODULE.EDIT_PLAN'),
      id: 'edit_plan',
      should_show: isPlanActive
    },
    {
      name: t('PATIENT_DETAILS_DRAWER.CCM_MODULE.DELETE_PLAN'),
      id: 'delete_plan',
      should_show: isPlanActive
    },
    {
      name: t('PATIENT_DETAILS_DRAWER.CCM_MODULE.RECORD_DETAILS'),
      id: 'record_care_plan_details',
      should_show: isPlanActive && !isExternalPlanActive
    },
    {
      name: t('CCM.ADD_TIME.ADD_TIME'),
      id: 'add_ccm_time',
      should_show: !isTimeRunningForCurrentPatient && patientDetails?.ccm_patient_archived !== true
    },
    {
      name: t('PATIENT_DETAILS_DRAWER.CCM_MODULE.ARCHIVE_CCM'),
      id: 'archive_ccm',
      should_show: patientDetails?.ccm_patient_archived === false
    },
    {
      name: t('CCM.VIEW_OR_EDIT_DETAILS_LINK'),
      id: 'view_or_edit_details',
      should_show: true
    },
    {
      name: t('PATIENT_DETAILS_DRAWER.CCM_MODULE.CANCEL_CCM'),
      id: 'cancel_ccm',
      should_show: true
    }
  ].filter((item: any) => item?.should_show);

  // * Create CCM plan */
  const onClickCreateCCMPlan = () => {
    setStateShowDialog(prevState => ({
      ...prevState,
      openCreatePlanDialog: true,
      editDialog: isPlanActive,
      patientName: HelperUtils.commaSeparatedFullName(
        patientDetails?.first_name,
        patientDetails?.last_name,
        patientDetails?.middle_name
      )
    }));
  };

  // * Delete CCM plan */

  const deleteCCM = async () => {
    try {
      const options: Record<string, any> = {};
      if (clinicId) {
        // FIX: Add clinic_id in the patient details api response when patient shared is off
        options.clinic_id = clinicId;
      }
      if (isExternalPlanActive) {
        options.is_external_care_plan = isExternalPlanActive;
      }
      const response = await deleteCCMPlan(
        groupId,
        patientDetails?.ccm_patient_id,
        options
      );
      if (response) {
        enqueueSnackbar(t('CCM.CCM_PLAN_DELETED'), SnackBarConfig('s'));

        setStateShowDialog(prevState => ({
          ...prevState,
          confirmationDialog: false
        }));
      }
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      throw err;
    }
  };

  const onClickDeleteCCMPlan = () => {
    setStateShowDialog(prevState => ({
      ...prevState,
      confirmationDialog: true,
      cancelCCMState: false,
      patientName: HelperUtils.commaSeparatedFullName(
        patientDetails?.first_name,
        patientDetails?.last_name,
        patientDetails?.middle_name
      )
    }));
  };

  // * Cancel CCM plan */
  const cancelCCM = async () => {
    try {
      const response = await cancelCCMPlan(
        groupId,
        patientDetails?.ccm_patient_id,
        {
          clinic_id: clinicId
        }
      );
      if (response) {
        enqueueSnackbar(t('CCM.CCM_PLAN_CANCELLED'), SnackBarConfig('s'));
        setStateShowDialog(prevState => ({
          ...prevState,
          confirmationDialog: false
        }));
      }
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      throw err;
    }
  };

  const closeStopTimerDialog = () => {
    setStateShowDialog(prevState => ({
      ...prevState,
      showStopTimerDialog: false
    }));
  };

  const handleCancelDialog = () => {
    setStateShowDialog(prevState => ({
      ...prevState,
      showStopTimerDialog: false
    }));
  };
  // ** Record details dialog */

  const onClickRecordDetails = () => {
    setStateShowDialog(prevState => ({
      ...prevState,
      openRecordDetailsDialog: true
    }));
  };

  const handleSaveDialog = () => {
    setStateShowDialog(prevState => ({
      ...prevState,
      showStopTimerDialog: false,
      confirmationDialog: recordDetailsEventBoolean ? false : true
    }));
    dispatch(_ccmResetTimer());
    if (recordDetailsEventBoolean) {
      dispatch(_startTimerfromPatientDrawer(true));
    }
  };
  const onClickCancelCCM = () => {
    setStateShowDialog(prevState => ({
      ...prevState,
      showStopTimerCancelCCM:
        isCCMTimerRunning &&
        patientDetails?.ccm_patient_id === runningCCMPatientId,
      confirmationDialog:
        isCCMTimerRunning &&
        patientDetails?.ccm_patient_id === runningCCMPatientId
          ? false
          : true,
      cancelCCMState: true,
      patientName: HelperUtils.commaSeparatedFullName(
        patientDetails?.first_name,
        patientDetails?.last_name,
        patientDetails?.middle_name
      )
    }));
  };

  const openStartTimerDialogToViewRecordDetails = () => {
    setStateShowDialog(prevState => ({
      ...prevState,
      showStartTimerDialogToViewRecordDetails: true,
      patientName: HelperUtils.commaSeparatedFullName(
        patientDetails?.first_name,
        patientDetails?.last_name,
        patientDetails?.middle_name
      )
    }));
  };

  const openRecordCarePlanDetails = () => {
    // ** check patient started the timer or not, if not show the alert dialog to start the timer
    if (!localStorageData?.ccmPatientTimerLogId) {
      openStartTimerDialogToViewRecordDetails();
    }
    if (
      isCCMTimerRunning &&
      patientDetails?.ccm_patient_id !== runningCCMPatientId
    ) {
      setStateShowDialog(prevState => ({
        ...prevState,
        stopTimerWarningDialog: true,
        recordDetailsEventBoolean: true,
        patientName: HelperUtils.commaSeparatedFullName(
          patientDetails?.first_name,
          patientDetails?.last_name,
          patientDetails?.middle_name
        )
      }));
    } else if (
      localStorageData?.ccmPatientTimerLogId &&
      isCCMTimerRunning &&
      patientDetails?.ccm_patient_id === runningCCMPatientId
    ) {
      onClickRecordDetails();
    }
  };

  const openCcmLogRecordDetails = (rowData: any) => {
    setStateShowDialog(prevState => ({
      ...prevState,
      showCcmLogRecordDetails: true,
      selectedRowData: rowData
    }));
  };
  const closeCcmLogRecordDetails = () => {
    setStateShowDialog(prevState => ({
      ...prevState,
      showCcmLogRecordDetails: false
    }));
  };

  const closeRecordDetailsDialog = () => {
    setStateShowDialog(prevState => ({
      ...prevState,
      openRecordDetailsDialog: false,
      recordDetailsEventBoolean: false
    }));
    dispatch(_startTimerfromPatientDrawer(false));
  };

  const handleStopTimer = () => {
    const currentTime = Date.now();

    dispatch(_ccmStopTimer(currentTime));

    setStateShowDialog(prevState => ({
      ...prevState,
      showStopTimerDialog: true
    }));
  };

  const openCcmTimeDialog = () => {
    setStateShowDialog(p => ({
      ...p,
      openAddCcmTimeDialog: true
    }));
  };

  // ** function to create an external plan outside of the system ** //
  const onClickCreateExternalCarePlan = async () => {
    try {
      setIsLoading(true);
      const options: {clinic_id?: string | number} = {};
      if (CompletePatientDetails?.clinicId) {
        options.clinic_id = CompletePatientDetails?.clinicId;
      }
      const response: any = await createExternalCCMPlanforPatient(
        groupId,
        patientDetails?.ccm_patient_id,
        options
      );
      if (response) {
        setIsLoading(false);
        enqueueSnackbar(
          'Marked as external care plan successfully',
          SnackBarConfig('s')
        );
        CommunicationService.sendEvent({
          action: 'CCM_PLAN_CREATED',
          data: {
            ccmPatientId: patientDetails?.ccm_patient_id
          }
        });
      }
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      setIsLoading(false);
    }
  };

  const archiveCCM = async () => {
    try {
      const queryParams: {clinic_id?: string | number} = {};
      if (clinicId) {
        queryParams.clinic_id = clinicId;
      }
      const response = await archiveCCMPatient(
        groupId,
        patientDetails?.ccm_patient_id,
        queryParams
      );
      if (response) {
        enqueueSnackbar(response?.message || t('CCM.CCM_PATIENT_ARCHIVED'), SnackBarConfig('s'));
        dispatch(
          _setPatientDrawerPatientDetails(
            groupId,
            clinicId,
            patientDetails?.patient_id
          )
        );
      }
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      throw err;
    }
  };

  const handleClinicActionItemClick = (item: CustomPopOverListItemType) => {
    if (item?.id === 'create_plan') {
      onClickCreateCCMPlan();
    } else if (item?.id === 'edit_plan') {
      onClickCreateCCMPlan();
    } else if (item?.id === 'delete_plan') {
      onClickDeleteCCMPlan();
    } else if (item?.id === 'cancel_ccm') {
      onClickCancelCCM();
    } else if (item?.id === 'record_care_plan_details') {
      openRecordCarePlanDetails();
    } else if (item?.id === 'add_ccm_time') {
      openCcmTimeDialog();
    } else if (item?.id === 'create_external_care_plan') {
      onClickCreateExternalCarePlan();
    } else if (item?.id === 'view_or_edit_details') {
      handleShowEditPatientDetailsDialog(patientLogs?.rows[0], true, true);
    } else if (item?.id === 'archive_ccm') {
      archiveCCM();
    }
  };

  const handleClinicAction = (event: any) => {
    setRemainderAnchorEl(event.currentTarget);
  };
  const renderPopOverItems = (): ReactElement => {
    return (
      <CustomPopOver
        open={openPopover}
        anchorEl={remainderAnchorEl}
        listItems={popOverItems}
        position="bottom-end"
        handleClose={() => {
          setPopoverOpen(false);
        }}
        handleListItemClick={handleClinicActionItemClick}
      />
    );
  };
  const renderMoreButton = (): ReactElement => {
    return (
      <div className="moreOptions">
        <Button
          color="primary"
          variant="outlined"
          endIcon={
            openPopover ? (
              <ExpandLess className="expand-icon" />
            ) : (
              <ExpandMore className="expand-icon" />
            )
          }
          ref={anchorRef}
          onClick={e => {
            handleClinicAction(e);
            setPopoverOpen(true);
          }}
          className="ccm-more-options">
          {t('PATIENT_DETAILS_DRAWER.CCM_MODULE.MORE_OPTIONS')}
        </Button>
        {remainderAnchorEl && openPopover && renderPopOverItems()}
      </div>
    );
  };
  const navigateToMessages = () => {
    dispatch(_setActiveTab(PatientsTabKeys.MESSAGES));
  };

  const renderHeader = () => {
    return (
      <div className="header">
        <div className="ccm-title-wrapper">
          <div className="ccm-title-p1">
            {t('PATIENT_DETAILS_DRAWER.CCM_MODULE.TITLE')}
          </div>
          <div className={'time-spent-wrapper'}>
            <div>
              {`Time spent in ${patientLogs?.total_time_spent?.month.replace(
                ',',
                ''
              )}:`}
              &nbsp;
            </div>
            <div className="total-time">
              {secondsToTimeFormat(patientLogs?.total_time_spent?.time_spent)}
            </div>
          </div>
        </div>

        <div className="options">
          <Link className="link-style" onClick={() => navigateToMessages()}>
            {t('PATIENT_DETAILS_DRAWER.CCM_MODULE.SEND_MESSAGE')}
          </Link>
          <div>{renderMoreButton()}</div>
        </div>
      </div>
    );
  };

  const resetPagesInGrid = (pageNumber?: number) => {
    if (
      tableRef.current?.onQueryChange &&
      typeof tableRef.current.onQueryChange === 'function'
    ) {
      if(typeof pageNumber === 'number') {
        tableRef.current.onQueryChange({page: pageNumber});
      } else {
        tableRef.current.onQueryChange();
      }
    }
  };

  React.useEffect(() => {
    if (startDate) {
      resetPagesInGrid(0);
    }
  }, [startDate]);

  useEffect(() => {
    // start the timer for another patient and showing the record details dialog
    if (startTimerfromPatientDrawer) {
      setTimeout(() => {
        onClickRecordDetails();
      }, 500);
    }
  }, [startTimerfromPatientDrawer]);

  useEffect(() => {
    const subscription = CommunicationService.getEvent().subscribe(event => {
      if (
        event.action === 'ADDED_CCM_TIME' ||
        event.action === 'STOPPED_CCM_TIMER' ||
        (event.action === 'MARK_PREVIOUS_FOLLOW_UP_NOTES_AS_DONE' &&
          event.data.patientId == patientDetails?.patient_id)
      ) {
        resetPagesInGrid();
      }
    });
    const unsubscribe = () => {
      subscription.unsubscribe();
    };
    return unsubscribe;
  }, [patientDetails?.patient_id]);

  useEffect(() => {
    fetchCCMPatientTimeLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showIgnoredLogs]);
  const markPrevFollowUpNotesAsDone = async (logId: number) => {
    try {
      const payload = {
        status: FOLLOW_UP_NOTES_LOG_STATUS.COMPLETED
      };
      if (groupId && patientDetails?.ccm_patient_id && logId) {
        await updatePrevFollowUpNotesLog(
          groupId,
          patientDetails?.ccm_patient_id,
          logId,
          payload
        );
        resetPagesInGrid();
        const timerDataStr = Storage.getItem(
          CCMConstants.STORAGE_CCM_TIMER_DATA
        );
        if (timerDataStr) {
          const parsedTimerData = JSON.parse(timerDataStr);
          if (
            parsedTimerData?.ccmPanelData?.prevFollowUpNotesLogId == logId &&
            parsedTimerData?.ccmPanelData?.ccmPatientId ==
              patientDetails?.ccm_patient_id
          ) {
            Storage.setItem(
              CCMConstants.STORAGE_CCM_TIMER_DATA,
              JSON.stringify({
                ...parsedTimerData,
                ccmPanelData: {
                  ...parsedTimerData.ccmPanelData,
                  prevFollowUpNotes: '',
                  prevFollowUpNotesLogId: undefined
                }
              })
            );
            CommunicationService.sendEvent({
              action: 'CCM_PANEL_DATA_UPDATED',
              data: null
            });
          }
        }
      }
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
    }
  };
  const clinicList = useSelector((state: any) => state.clinics.list || []);

  const getClinicTimeZone = (_clinicId: string): string => {
    let timezone = '';
    if (clinicList && Array.isArray(clinicList)) {
      const clinic = clinicList.find(c => c.id === _clinicId);
      if (clinic) {
        timezone = clinic?.zone;
      }
    }
    return timezone;
  };

  // TODO: Replace this with the redux value once the patient shared redux state issue is fixed
  const {userPermissions} = useSelector((state: State) => state.auth);
  let patientShared = false;
  if (groupId) {
    patientShared =
      userPermissions?.[groupId]?.['group']?.[
        AppPermissions.PATIENT_MENU_PERMISSIONS.PATIENT_SHARED
      ] === true;
  }

  const fetchCCMUsersList = async () => {
    try {
      // eslint-disable-next-line camelcase
      const options: {clinic_id?: number | string} = {};
      if (!patientShared) {
        options['clinic_id'] = clinicId;
      }
      const response = await getAllCCMUsersOfClinicGroup(groupId, options);
      setCcmUsers(response?.data?.rows);
    } catch (error: any) {
      enqueueSnackbar(error && error.message, SnackBarConfig('e'));
      throw error;
    }
  };

  useEffect(() => {
    fetchCCMUsersList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderAssigneeName = (assigneeId: number) => {
    const assignee = ccmUsers.find(user => user.id === assigneeId);
    return (
      HelperUtils.commaSeparatedFullName(
        assignee?.first_name,
        assignee?.last_name
      ) || '-'
    );
  };

  const renderCCMAssignedUserAndDueDate = (): ReactElement => {
    return (
      <CCMAssigneeAndDueDateDialog
        open={openAssigneeDueDateDialog}
        onClose={(res: string) => {
          if (res === 'confirm') {
            resetPagesInGrid();
          }
          setStateShowDialog(p => ({
            ...p,
            openAssigneeDueDateDialog: false,
            selectedRowCCMPatientId: null,
            selectedRowLogId: null,
            selectedPatientName: ''
          }));
        }}
        logId={selectedRowLogId}
        ccmPatientId={selectedRowCCMPatientId}
        patientName={selectedPatientName}
      />
    );
  };

  const getRowReasons = (reasonsArray: string[] | null) => {
    // Check if reasonsArray is a valid array
    if (!Array.isArray(reasonsArray) || reasonsArray.length === 0) {
      return '-';
    }
    return reasonsArray.join(', ');
  };

  const getShouldShowFollowUpNotes = (fpNotes: any) => {
    return (
      fpNotes?.follow_up_notes ||
      fpNotes?.follow_up_notes_assignee ||
      fpNotes?.follow_up_notes_due_date
    );
  };

  const renderCCMPatientDetails = () => {
    return patientDetails?.ccm_patient_id ? (
      <>
        {renderHeader()}
        {renderBillingMonth()}

        <GridTable
          tableRef={tableRef}
          columns={[
            {
              title: t('PATIENT_DETAILS_DRAWER.CCM_MODULE.START_TIME'),
              field: 'start_time',
              sorting: true,
              headerStyle: {
                ...GuarantorHeaderStyle,
                width: '11%'
              },
              cellStyle: {
                ...CCMPatientPlanRowLogsStyle,
                width: '11%',
                whiteSpace: 'nowrap'
              },
              render: (rowData: any) => {
                return (
                  <div>
                    {appointmentsDateTimeFormat(
                      rowData?.start_time,
                      getClinicTimeZone(clinicId)
                    ) || '-'}
                  </div>
                );
              }
            },
            {
              title: t('PATIENT_DETAILS_DRAWER.CCM_MODULE.END_TIME'),
              field: 'stop_time',
              sorting: true,
              cellStyle: {
                ...CCMPatientPlanRowLogsStyle,
                width: '11%',
                whiteSpace: 'nowrap'
              },
              headerStyle: {
                ...GuarantorHeaderStyle,
                width: '11%'
              },
              render: (rowData: any) => {
                return (
                  <div>
                    {appointmentsDateTimeFormat(
                      rowData?.stop_time,
                      getClinicTimeZone(clinicId)
                    ) || '-'}
                  </div>
                );
              }
            },
            {
              title: t('PATIENT_DETAILS_DRAWER.CCM_MODULE.DURATION'),
              field: 'time_spent',
              sorting: true,
              cellStyle: {
                ...CCMPatientPlanRowLogsStyle,
                width: '7%'
              },
              headerStyle: {
                ...GuarantorHeaderStyle,
                width: '7%'
              },
              render: (rowData: any) => {
                return (
                  <div>
                    {rowData?.time_spent
                      ? `${secondsToTimeFormat(rowData?.time_spent)}`
                      : 0}
                  </div>
                );
              }
            },
            {
              title: t('PATIENT_DETAILS_DRAWER.CCM_MODULE.NOTES'),
              field: 'notes',
              sorting: true,
              cellStyle: {
                ...CCMPatientPlanRowLogsStyle,
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                width: '15%'
              },
              headerStyle: {
                ...GuarantorHeaderStyle,
                width: '15%'
              },
              render: (rowData: any) => {
                const ccmNotes = rowData?.notes || '';
                const maxCharacters = 15;
                if (!rowData?.notes) {
                  return '-';
                }
                return (
                  <div>
                    {ccmNotes?.length <= maxCharacters ? (
                      <p>{rowData?.notes}</p>
                    ) : (
                      <p>
                        {ccmNotes.slice(0, maxCharacters)}
                        {'... '}
                        <span
                          onClick={() => {
                            setStateShowDialog(p => ({
                              ...p,
                              moreDetails: true,
                              notes: rowData?.notes,
                              moreDetailsTitle: t(
                                'PATIENT_DETAILS_DRAWER.CCM_MODULE.NOTES'
                              )
                            }));
                          }}
                          className="link-text-style"
                          style={{cursor: 'pointer'}}>
                          {t('CCM.MORE_DETAILS')}
                        </span>
                      </p>
                    )}
                  </div>
                );
              }
            },
            {
              title: t('PATIENT_DETAILS_DRAWER.CCM_MODULE.FOLLOW_UP_NOTES'),
              field: 'follow_up_notes',
              cellStyle: {
                ...GuarantorCellStyle,
                ...CCMPatientPlanRowLogsStyle,
                whiteSpace: 'nowrap',
                width: '15%',
                minWidth: '12rem'
              },
              headerStyle: {
                ...GuarantorHeaderStyle,
                width: '15%',
                minWidth: '12rem'
              },
              render: (rowData: any) => {
                const followUpNotes = rowData?.follow_up_notes || '';
                const maxCharacters = 15;
                const shouldShowFollowUpNotes = getShouldShowFollowUpNotes(
                  rowData
                );
                if (!shouldShowFollowUpNotes) {
                  return '-';
                }
                return (
                  <div className={'follow-up-notes-column'}>
                    {followUpNotes.length <= maxCharacters ? (
                      <p>{rowData?.follow_up_notes || '-'}</p>
                    ) : (
                      <p>
                        {followUpNotes.slice(0, maxCharacters)}
                        {'... '}
                        <span
                          onClick={() => {
                            setStateShowDialog(p => ({
                              ...p,
                              moreDetails: true,
                              notes: rowData?.follow_up_notes,
                              moreDetailsTitle: t(
                                'PATIENT_DETAILS_DRAWER.CCM_MODULE.FOLLOW_UP_NOTES'
                              )
                            }));
                          }}
                          className="link-text-style"
                          style={{cursor: 'pointer'}}>
                          {t('CCM.MORE_DETAILS')}
                        </span>
                      </p>
                    )}
                    {rowData?.status === FOLLOW_UP_NOTES_LOG_STATUS.PENDING && (
                      <div
                        onClick={() => markPrevFollowUpNotesAsDone(rowData.id)}
                        // ${classes.markFollowUpNoteAsDoneWrapper}
                        className={`link-text-style mark-follow-up-note-as-done`}>
                        <CheckCircleOutlineIcon fontSize="small" />
                        <p>{t('CCM.MARK_PREV_FOLLOW_UP_NOTE_AS_DONE')}</p>
                      </div>
                    )}
                  </div>
                );
              }
            },
            {
              title: t('CCM.FOLLOW_UP_NOTES_COLUMN.FOLLOW_UP_NOTES_DETAILS'),
              field: 'follow_up_notes_details',
              cellStyle: {
                ...GuarantorCellStyle,
                ...CCMPatientPlanRowLogsStyle,
                whiteSpace: 'nowrap',
                width: '15%',
                minWidth: '15rem'
              },
              headerStyle: {
                ...GuarantorHeaderStyle,
                width: '15%',
                minWidth: '15rem'
              },
              render: (rowData: any) => {
                const showAddedUser =
                  rowData?.status === FOLLOW_UP_NOTES_LOG_STATUS.PENDING &&
                  rowData?.follow_up_notes_added_user;
                const showCompletedBy =
                  rowData?.status === FOLLOW_UP_NOTES_LOG_STATUS.COMPLETED &&
                  rowData?.status_updated_by_user;
                const noFollowUpDetails = !showAddedUser && !showCompletedBy;
                return (
                  <div>
                    {showAddedUser && (
                      <div className="follow-up-notes-added">
                        <p style={{display: 'flex', alignItems: 'baseline'}}>
                          <p style={{paddingRight: '0.2rem'}}>
                            {t(
                              'CCM.FOLLOW_UP_NOTES_COLUMN.FOLLOW_UP_NOTES_ASSIGNEE'
                            )}
                            :{' '}
                            {renderAssigneeName(
                              rowData?.follow_up_notes_assignee
                            )}
                          </p>
                          <p
                            onClick={() =>
                              setStateShowDialog(p => ({
                                ...p,
                                openAssigneeDueDateDialog: true,
                                selectedRowLogId: rowData?.id,
                                selectedRowCCMPatientId:
                                  rowData?.ccm_patient_id,
                                selectedPatientName: HelperUtils.commaSeparatedFullName(
                                  patientDetails?.first_name,
                                  patientDetails?.last_name,
                                  patientDetails?.middle_name
                                )
                              }))
                            }
                            className={`link-text-style`}>
                            <p>{t('Change/Edit')}</p>
                          </p>
                        </p>
                        <p style={{paddingBottom: '0.2rem'}}>
                          {t(
                            'CCM.FOLLOW_UP_NOTES_COLUMN.FOLLOW_UP_NOTES_DUE_DATE'
                          )}
                          :{' '}
                          {HelperUtils.formatDisplayDate(
                            rowData?.follow_up_notes_due_date
                          )}
                        </p>
                        <p style={{paddingBottom: '0.2rem'}}>
                          {t('CCM.FOLLOW_UP_NOTES_COLUMN.ADDED_BY')}:{' '}
                          {HelperUtils.commaSeparatedFullName(
                            rowData?.follow_up_notes_added_user?.first_name,
                            rowData?.follow_up_notes_added_user?.last_name
                          ) || '-'}
                        </p>
                        <p>
                          {rowData?.follow_up_notes_added_at &&
                            appointmentsDateTimeFormat(
                              rowData?.follow_up_notes_added_at,
                              getClinicTimeZone(clinicId)
                            )}
                        </p>
                      </div>
                    )}

                    {showCompletedBy && (
                      <div className="follow-up-notes-completed">
                        <p>
                          {t('CCM.FOLLOW_UP_NOTES_COLUMN.COMPLETED_BY')}:{' '}
                          {HelperUtils.commaSeparatedFullName(
                            rowData?.status_updated_by_user?.first_name,
                            rowData?.status_updated_by_user?.last_name
                          ) || '-'}
                        </p>
                        {rowData?.status_updated_at && (
                          <p>
                            {appointmentsDateTimeFormat(
                              rowData?.status_updated_at,
                              getClinicTimeZone(clinicId)
                            ) || '-'}
                          </p>
                        )}
                      </div>
                    )}
                    {noFollowUpDetails && '-'}
                  </div>
                );
              }
            },
            {
              title: t('PATIENT_DETAILS_DRAWER.CCM_MODULE.REASON'),
              field: 'activity_reasons',
              sorting: true,
              cellStyle: {
                ...GuarantorCellStyle,
                ...CCMPatientPlanRowLogsStyle,
                minWidth: '12rem'
              },
              headerStyle: {
                ...GuarantorHeaderStyle,
                minWidth: '12rem'
              },
              render: (rowData: any) => {
                return (
                  <div>{getRowReasons(rowData?.activity_reasons) || '-'}</div>
                );
              }
            },
            {
              title: t('PATIENT_DETAILS_DRAWER.CCM_MODULE.PLAN_RECORD'),
              field: 'plan record',
              sorting: true,
              cellStyle: {
                ...GuarantorCellStyle,
                ...CCMPatientPlanRowLogsStyle,
                width: '12%',
                minWidth: '11rem'
              },
              headerStyle: {
                ...GuarantorHeaderStyle,
                width: '12%',
                minWidth: '11rem'
              },
              render: (rowData: any) => {
                return (
                  <div>
                    {rowData?.is_plan_logs_exist ? (
                      <div
                        className="link-text-style"
                        onClick={(e: any) => {
                          openCcmLogRecordDetails(rowData);
                          e.stopPropagation();
                        }}>
                        {t('PATIENT_DETAILS_DRAWER.CCM_MODULE.VIEW_DETAILS')}
                      </div>
                    ) : (
                      <div className="plan-logs-exist-col">{'-'}</div>
                    )}
                  </div>
                );
              }
            },
            {
              title: t('PATIENT_DETAILS_DRAWER.CCM_MODULE.STAFF_NAME'),
              field: 'staff name',
              sorting: true,
              cellStyle: {
                ...GuarantorCellStyle,
                ...CCMPatientPlanRowLogsStyle,
                width: '12%',
                minWidth: '10rem'
              },
              headerStyle: {
                ...GuarantorHeaderStyle,
                width: '12%',
                minWidth: '10rem'
              },
              render: (rowData: any) => {
                return <div>{rowData?.staff_name || '-'}</div>;
              }
            },
            {
              title: t('COMMON.ACTIONS'),
              sorting: false,
              field: 'actions',
              cellStyle: {
                ...GuarantorCellStyle,
                ...CCMPatientPlanRowLogsStyle,
                width: '10%',
                minWidth: '10rem'
              },
              headerStyle: {
                ...GuarantorHeaderStyle,
                whiteSpace: 'nowrap',
                width: '10%',
                minWidth: '10rem'
              },
              render: row => {
                return (
                  <div className="actions">
                    <Tooltip
                      title={t('CCM.VIEW_OR_EDIT_DETAILS_LINK').toString()}>
                      <div
                        className="link-text-style"
                        onClick={() => {
                          handleShowEditPatientDetailsDialog(row, true, true);
                        }}>
                        {t('CCM.VIEW_OR_EDIT_DETAILS_LINK')}
                      </div>
                    </Tooltip>
                    {isCCMAdminRole &&
                      <Tooltip title={t('CCM.IGNORE').toString()}>
                        <div
                          className="link-text-style"
                          onClick={() => {
                            handleIgnoreFunctionality(row.id, true);
                          }}>
                          {t('CCM.IGNORE')}
                        </div>
                      </Tooltip>
                    }
                  </div>
                );
              }
            }
          ]}
          data={query => {
            return new Promise((resolve, reject) => {
              fetchCCMPatientTimeLogs(
                query.pageSize,
                query.page * query.pageSize
                // {
                //   sort: query.orderBy?.field,
                //   order: query.orderDirection
                // }
              )
                .then((res: any) => {
                  const totalCount = parseInt(res?.data?.count);
                  if (res?.data?.rows && totalCount > 0) {
                    // setStateShowDialog(prevState => ({
                    //   ...prevState,
                    //   apiResponse: res?.data?.rows
                    // }));

                    const totalPages = Math.ceil(totalCount / query.pageSize); // 1 based index
                    const safeTotalPages = Math.max(totalPages - 1, 0); // 0 based index

                    // If the current page is the greater then the last page and there are no records, navigate to the previous page
                    if(res.data.rows.length === 0 && query.page > safeTotalPages) {
                      setTimeout(() => {
                        resetPagesInGrid(safeTotalPages);
                      }, 0);
                      return;
                    }

                    resolve({
                      data: res.data.rows,
                      page: query.page,
                      totalCount
                    });
                  } else {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 0
                    });
                  }
                })
                .catch((err: any) => {
                  reject();
                });
            });
          }}
          // localization={{
          //   body: {
          //     emptyDataSourceMessage: CCMDetails.length
          //       ? t('ACTION_HISTORY.RECORDS')
          //       : t('PATIENT_DETAILS_DRAWER.CCM_MODULE.NO_DATA')
          //   }
          // }}
          options={{
            ...DEFAULT_GRID_TABLE__OPTIONS,
            search: false,
            showTitle: false,
            toolbar: false,
            sorting: true,
            paging: true,
            emptyRowsWhenPaging: false,
            pageSize: PAGINATION_SIZE.CCM_PATIENT_TIME_LOGS,
            pageSizeOptions:
              CUSTOM_PAGINATION_SIZE_OPTIONS.CCM_PATIENT_TIME_LOGS,
            showEmptyDataSourceMessage: true,
            maxBodyHeight: '100%',
            tableLayout: 'auto',
            selection: false,
            draggable: false,
            headerStyle: {
              color: DEFAULT_BLACK_COLOR,
              fontFamily: APP.FONT_FAMILY.MEDIUM,
              flexDirection: 'row'
            }
          }}
          style={{
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            boxShadow:
              '0 0 0 1px rgb(63 63 68 / 5%), 0 1px 3px 0 rgb(63 63 68 / 15%)'
          }}
        />
      </>
    ) : (
      <div className={'not-enrolled'}>
        {t('PATIENT_DETAILS_DRAWER.CCM_MODULE.NOT_ENROLED')}
      </div>
    );
  };

  const renderMoreNotesDetails = () => {
    return (
      <CCMShowFullNotesDialog
        open={moreDetails}
        onClose={() => {
          setStateShowDialog(prevState => ({
            ...prevState,
            moreDetails: false,
            notes: '',
            moreDetailsTitle: ''
          }));
        }}
        notes={notes}
        title={moreDetailsTitle}
      />
    );
  };

  useEffect(() => {
    const subscription = CommunicationService.getEvent().subscribe(event => {
      if (
        event.action === 'CCM_PLAN_CREATED' ||
        event.action === 'CCM_PLAN_DELETED' ||
        event.action === 'CCM_PLAN_TASK_DETAILS_UPDATED'
      ) {
        dispatch(
          _setPatientDrawerPatientDetails(
            groupId,
            clinicId,
            patientDetails?.patient_id
          )
        );
      }
    });
    return () => subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const patientFullName = `${patientDetails?.['first_name'] ?? ''} ${
    patientDetails?.['middle_name'] ?? ''
  } ${patientDetails?.['last_name'] ?? ''}`;

  const userGroups = useSelector((state: any) => state.auth.userGroups);
  let selectedGroup: any;

  if (userGroups && Array.isArray(userGroups) && userGroups.length > 0) {
    selectedGroup = userGroups.find(item => item.id == groupId);
  }

  const closeCcmTimeDialog = () => {
    setStateShowDialog(p => ({
      ...p,
      openAddCcmTimeDialog: false
    }));
  };

  const [
    editPatientDetailsDialogState,
    setEditPatientDetailsDialogState
  ] = useState({
    open: false,
    ccmPatientId: null as number | null,
    defaultValues: {} as Partial<any>,
    patientName: null as string | null,
    showBillingProvider: false,
    showActiveProblems: false
  });
  const handleShowEditPatientDetailsDialog = async (
    row: any,
    showBillingProvider: boolean,
    showActiveProblems: boolean
  ) => {
    setEditPatientDetailsDialogState({
      open: true,
      ccmPatientId: patientDetails?.ccm_patient_id,
      defaultValues: {
        billing_provider: row?.billing_provider
      },
      patientName: HelperUtils.commaSeparatedFullName(
        patientDetails?.first_name,
        patientDetails?.last_name,
        patientDetails?.middle_name
      ),
      showBillingProvider: showBillingProvider,
      showActiveProblems: showActiveProblems
    });
  };
  const handleIgnoreFunctionality = async (
    ccmLogId: number,
    isIgnored: boolean
  ) => {
    try {
      const options: any = {};
      if (isIgnored) {
        options.is_ignored = true;
      }
      if (clinicId) {
        options.clinic_id = clinicId;
      }
      const res = await ingnoreCCMLog(
        groupId,
        patientDetails?.ccm_patient_id,
        ccmLogId,
        options
      );
      enqueueSnackbar( res.message,SnackBarConfig('s'))
      fetchCCMPatientTimeLogs();
      resetPagesInGrid();
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      throw err;
    }
  };

  return (
    <>
      <div className="ccm-parent">{renderCCMPatientDetails()}</div>
      {openCreatePlanDialog && (
        <CCMCreatePlanDialog
          open={openCreatePlanDialog}
          fromEdit={editDialog}
          patientName={patientName}
          accountNumber={patientDetails?.patient_account_number || 0}
          onClose={response => {
            setStateShowDialog(prevState => ({
              ...prevState,
              openCreatePlanDialog: false
            }));
          }}
          ccmPatientId={patientDetails?.ccm_patient_id}
          clinicId={clinicId}
          isExternalPlanActiveProp={isExternalPlanActive}
        />
      )}
      {openRecordDetailsDialog && (
        <RecordDetailsDialog
          open={openRecordDetailsDialog}
          onClose={closeRecordDetailsDialog}
          patientName={HelperUtils.commaSeparatedFullName(
            patientDetails?.first_name,
            patientDetails?.last_name,
            patientDetails?.middle_name
          )}
          accountNumber={patientDetails?.patient_account_number || 0}
          groupId={groupId}
          clinicId={clinicId}
          patientId={patientDetails?.patient_id}
          ccmPatientId={patientDetails?.ccm_patient_id}
          isExternalPlanActiveProp={isExternalPlanActive}
        />
      )}
      {showCcmLogRecordDetails && (
        <CCMLogRecordDetailsDialog
          open={showCcmLogRecordDetails}
          onClose={closeCcmLogRecordDetails}
          patientName={HelperUtils.commaSeparatedFullName(
            patientDetails?.first_name,
            patientDetails?.last_name,
            patientDetails?.middle_name
          )}
          accountNumber={patientDetails?.patient_account_number || 0}
          groupId={groupId}
          clinicId={clinicId}
          patientId={patientDetails?.patient_id}
          ccmPatientId={patientDetails?.ccm_patient_id}
          selectedRowData={selectedRowData}
        />
      )}
      {confirmationDialog && (
        <ConfirmationDialog
          open={confirmationDialog}
          onClose={async response => {
            if (response === 'confirm') {
              if (!cancelCCMState) {
                await deleteCCM();
                // trigger the event to refresh the grid
                CommunicationService.sendEvent({
                  action: 'CCM_PLAN_DELETED',
                  data: {
                    ccmPatientId: patientDetails?.ccm_patient_id
                  }
                });
                // dispatch(_closePatientDrawer());
                dispatch(
                  _setPatientDrawerPatientDetails(
                    groupId,
                    clinicId,
                    patientDetails?.patient_id
                  )
                );
              } else if (cancelCCMState) {
                await cancelCCM();
                // trigger the event to refresh the grid
                CommunicationService.sendEvent({
                  action: 'CCM_PLAN_DELETED',
                  data: {
                    ccmPatientId: patientDetails?.ccm_patient_id
                  }
                });
                // dispatch(_closePatientDrawer());
                dispatch(
                  _setPatientDrawerPatientDetails(
                    groupId,
                    clinicId,
                    patientDetails?.patient_id
                  )
                );
              }
            } else {
              setStateShowDialog(prevState => ({
                ...prevState,
                confirmationDialog: false
              }));
            }
          }}
          title={
            !cancelCCMState
              ? t('CCM.CCM_PLAN_CONFIRMATION_DIALOG_DELETE_TITLE', {
                  name: `(${patientName})`
                })
              : t('CCM.CCM_PLAN_CONFIRMATION_DIALOG_CANCEL_TITLE', {
                  name: `(${patientName})`
                })
          }
          description={
            <Trans
              i18nKey={
                !cancelCCMState
                  ? t('CCM.CCM_PLAN_DELETE_SUBTITLE')
                  : t('CCM.CCM_PLAN_CANCEL_SUBTITLE')
              }
              components={[<strong key={'X'} />]}
            />
          }
        />
      )}
      {showStopTimerCancelCCM && (
        <WarningTimerDialog
          open={showStopTimerCancelCCM}
          onClose={() => {
            setStateShowDialog(prevState => ({
              ...prevState,
              showStopTimerCancelCCM: false
            }));
          }}
          onSave={() => {
            handleStopTimer();
          }}
          titleHeader={t('CCM.WARNING.ALERT_STOP_TIMER')}
          confirmBtnText={t('COMMON.YES')}
          contentBody={
            <Trans
              i18nKey={'CCM.WARNING.ALERT_STOP_TIMER_CONTENT'}
              values={{
                patient_name: patientName
              }}
              components={[<strong key={'X'} />]}
            />
          }
          cancelBtnText={t('COMMON.NO')}
        />
      )}
      {showStopTimerDialog && (
        <StopTimerDialog
          open={showStopTimerDialog}
          onClose={closeStopTimerDialog}
          onCancel={handleCancelDialog}
          onSave={handleSaveDialog}
        />
      )}
      {showStartTimerDialogToViewRecordDetails && (
        <WarningTimerDialog
          open={showStartTimerDialogToViewRecordDetails}
          onClose={() => {
            setStateShowDialog(prevState => ({
              ...prevState,
              showStartTimerDialogToViewRecordDetails: false
            }));
            //  added the setTimeout bcz after closing stop timer dialog showing the record details dialog,
            // in that intially we are not getting the data, so added the 500 ms delay to show the record details dialog to get the data.
          }}
          onSave={() => {
            dispatch(_startTimerfromPatientDrawer(true));
          }}
          titleHeader={t('CCM.WARNING.ALERT_START_TIMER')}
          confirmBtnText={t('COMMON.YES')}
          contentBody={
            <Trans
              i18nKey={'CCM.WARNING.ALERT_START_TIMER_BODY'}
              values={{
                patient_name: patientName
              }}
              components={[<strong key={'X'} />]}
            />
          }
          cancelBtnText={t('COMMON.NO')}
        />
      )}
      {stopTimerWarningDialog && (
        <WarningTimerDialog
          open={stopTimerWarningDialog}
          onClose={() => {
            setStateShowDialog(prevState => ({
              ...prevState,
              stopTimerWarningDialog: false
            }));
          }}
          onSave={() => {
            handleStopTimer();
          }}
          titleHeader={t('CCM.WARNING.ALERT_STOP_TIMER')}
          confirmBtnText={t('COMMON.YES')}
          contentBody={
            <Trans
              i18nKey={'CCM.WARNING.ALERT_TIMER_STARTED'}
              values={{
                patient_name: localStorageData?.patientName || '',
                new_patient_name: patientName
              }}
              components={[<strong key={'X'} />]}
            />
          }
          cancelBtnText={t('COMMON.NO')}
        />
      )}

      {/* This dialog for Add  CCM Time manually*/}
      {openAddCcmTimeDialog && (
        <AddCcmTimeDialog
          open={openAddCcmTimeDialog}
          onClose={() => closeCcmTimeDialog()}
          patientName={patientFullName}
          accountNumber={patientDetails?.patient_account_number}
          ccmPatientId={patientDetails?.ccm_patient_id}
          clinicId={clinicId}
          patientId={patientDetails?.patient_id}
        />
      )}
      {moreDetails && renderMoreNotesDetails()}
      {openAssigneeDueDateDialog && renderCCMAssignedUserAndDueDate()}
      {editPatientDetailsDialogState.open && (
        <CCMPatientProblemsDrawer
          open={editPatientDetailsDialogState.open}
          closeDrawer={() =>
            setEditPatientDetailsDialogState(prev => ({
              ...prev,
              open: false
            }))
          }
          patientProblemsData={editPatientDetailsDialogState}
          clinicId={selectedGroup?.patients_shared === false ? clinicId : null}
          refreshMainGrid={resetPagesInGrid}
        />
      )}
    </>
  );
};

export default React.memo(
  WithPermission(
    CCMPatientsDrawerDetails,
    AppPermissions.CCM.NAME,
    AppPermissions.CCM.READ
  )
);
